(function ($, global) {

  /**
   * Вспомогательные функции реквизита "Документ".
   * @since 5.5.0.1000
   */
  var DocumentSelectRequisite = global.BaseSelectRequisite.extend({
    className: 'DocumentSelectRequisite',

    // Инициализирует компоненту.
    _initControl: function () {
      var me = this;
      me._super();

      var jInput = me._jInput;

      jInput.parent().hover(
        function () { me._showAdditionalButtons(this, jInput, me.isAccessDenied); },
        function () { me._hideAdditionalButtons(this, jInput); }
      );

      jInput.on('contextmenu', function (e) {
        e.preventDefault();
        e.stopPropagation();
        return false;
      });

      var referenceSelectPluginSettings = me.referenceSelectPluginSettings || jInput.data('settings');
      referenceSelectPluginSettings = $.extend(referenceSelectPluginSettings, {
        hidd: me._jHidden,
        dataProvider: window.Core.requisites.DocumentSelectDataProvider
      });
      jInput.ReferenceSelect(referenceSelectPluginSettings, jInput.parent().parent().find('div.Req_Icon'));

      jInput.result(function (event, data) {
        me._attachResult(
          jInput,
          data,
          me.afterSelectCallback,
          me.isNeedCallAfterSelectCallbackOnClear
        );
      });
    },

    /**
     * Загружает дополнительнные данные для ссылок. Например, наименование или ведущие реквизиты.
     *
     * @method _loadExtendedDataForLinks
     * @param links Массив ссылок.
     * @return {Deferred<Object>} Ссылка с загруженныеми данными.
     * @private
     * @see https://api.jquery.com/category/deferred-object/
     */
    _loadExtendedDataForLinks: function (links) {
      var d = $.Deferred();

      var link = links[0]; // множественный выбор пока что не поддерживаем не мы, не билдер.

      //setTimeout нужен для IE11, т.к. этот метод вызывается в событии onPaste и IE блокирует запросы в нем. Решение от сюда https://stackoverflow.com/questions/26910691/jquery-ajax-request-ie11-access-is-denied
      setTimeout((function (_link) {
        return function () {
          WA.SRV.document.getNameById([_link.id]).done(function (documentName) {
            _link.name = documentName;
            d.resolve([_link]);
          }).fail(function (err) {
            d.reject(err);
          });
        };
      })(link), 1);

      return d.promise();
    },

    // Парсинг подходящей строки в ссылку.
    _parseSuitableUrl: function (url) {
      var idIndex = url.toLowerCase().indexOf('&id=');
      if (idIndex !== -1) {
        var idStr = url.substr(idIndex + 4); //+4 это пропуск "&id=", parseInt отбрасывает всё ненужно после первых цифр, поэтому нам не важно где кончается id. Например, parseInt('123&param=value') -> 123
        var id = parseInt(idStr, 10);
        return new WA.Link(id, OBJECT_TYPE.EDOCUMENT);
      }
      return null;
    },

    // Обработка выбора документа в выпадающем списке.
    _attachResult: function (inp, data, afterSelectFunc, isNeedCallFuncOnClear) {
      if (data) {
        if ($.isFunction(afterSelectFunc)) afterSelectFunc(data[0]);
      } else {
        //вызываем функцию если поле очищено
        if (isNeedCallFuncOnClear) afterSelectFunc(null);
        inp.SetValue(null);
      }
      inp.change();
    },

    // Показать дополнительные кнопки.
    _showAdditionalButtons: function (container, inp, isAccessDenied) {
      var jIcons = $(container).find('.Req_AdditionalIcons');
      jIcons.show();

      var jOpenIco = jIcons.find('.OpenCardIco');
      var jOpenBodyIco = jIcons.find('.OpenBodyIco');

      var selVal = $('#hSelID_' + inp.attr('id')).val();
      if (selVal != null && selVal !== '*' && !isAccessDenied && (inp.data('selected') == "true" || inp.data('selected') == "selected" || inp.data('selected') === true) && /^\d+$/.test(selVal)) {
        jOpenIco.show();
        jOpenBodyIco.show();
      } else {
        jOpenIco.hide();
        jOpenBodyIco.hide();
      }
    },

    // Скрыть дополнительные кнопки.
    _hideAdditionalButtons: function (container, inp) {
      $(container).find('.Req_AdditionalIcons').hide().find('p').hide();
    }

  }, {
    // Тут статические методы.

    // Открыть карточку выбранного документа.
    openSelected: function (jOpenIco, inputId) {
      var selVal = $('#hSelID_' + inputId).val();
      var link = new WA.Link(+selVal, OBJECT_TYPE.EDOCUMENT);
      link.open();
    },

    // Открыть тело выбранного документа.
    openSelectedBody: function (jOpenIco, inputId) {
      var docId = +$('#hSelID_' + inputId).val();

      if (g_defaultListAction === 'open') {
        OpenWithAgent({ id: docId }, true);
        return;
      } else if (g_defaultListAction === 'viewineditor') {
        OpenWithAgent({ id: docId }, false);
        return;
      }

      // Если ничего не получилось, то открываем предпросмотр.
      ExportEDoc(docId, true, 0, true);

    }
  });

  global.DocumentSelectRequisite = DocumentSelectRequisite;

})(jQuery, window.Core.requisites);
